import { useWindowSize } from './useWindowSize';

const MAX_MOBILE_VIEWPORT = 1024;

export const useIsMobileViewport = () => {
    const { width } = useWindowSize();

    return width < MAX_MOBILE_VIEWPORT;
};
